fragment PrintCostFragment on PrintCost {
    id

    printTechnique {
        ...PrintTechniqueFragment
    }

    print_technique_id

    key
    info
    color
    start_cost_gross
    start_cost_net
    prices_gross
    prices_net
}